import styled from "styled-components";
import { ContainerSection } from "../styles";
import { TableCell } from "@mui/material";

interface IAreaForm {
	gridTemplateColumns?: string;
}

export const Container = styled(ContainerSection)``;

export const AreaForm = styled.div<IAreaForm>`
	display: grid;
	grid-template-columns: ${(props) => props.gridTemplateColumns || "1fr 1fr 1fr"};
	gap: 1rem;

	@media (max-width: 426px) {
		grid-template-columns: 1fr;

		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;

export const AreaInputNumber = styled.div`
	position: relative;
`;

export const AreaCheckbox = styled.div`
	position: absolute;
	top: 14px;
	right: 0.6rem;
	margin: 0;

	.MuiFormControlLabel-root {
		margin: 0;
	}

	.MuiCheckbox-root {
		padding: 0;
	}

	.MuiCheckbox-colorSecondary.Mui-checked {
		color: #fab01c;
	}
`;
export const TextEllipsis = styled.span`
	display: block;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 100%;
	font-size: 0.8rem;
`;

export const EllispsisTableCell = styled(TableCell)`
	max-width: 200px;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		max-width: unset !important;
	}
`;
